export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_svp-agent-powerup/artifacts/kiruw5h2_agentsvphero.png";
export const HERO_IMAGE_SIMPLE = "https://customer-assets.emergentagent.com/job_svp-agent-powerup/artifacts/bzpvljd3_agentsvp1.png";
export const HERO_IMAGE_DESK = "https://customer-assets.emergentagent.com/job_svp-agent-powerup/artifacts/oaqyj53a_agentsvp2.png";
export const LOGO_IMAGE = "https://customer-assets.emergentagent.com/job_svp-agent-powerup/artifacts/o4d55d23_logoagentsvp.webp";
export const HERO_IMAGE_IDEA = "https://customer-assets.emergentagent.com/job_svp-agent-powerup/artifacts/exor1lmr_agentsvp3.webp";

export const NAV_LINKS = [
  { label: "Základní školy", href: "/zakladni-vzdelavani", isPage: true },
  { label: "Mateřské školy", href: "/predskolni-vzdelavani", isPage: true },
  { label: "Časté dotazy", href: "#faq" },
  { label: "Kontakt", href: "#kontakt" }
];

export const BENEFITS = [
  {
    id: 1,
    title: "Úspora času 95%",
    description: "Tradiční způsob: 40-80 hodin práce. S Agent ŠVP: 1-2 hodiny.",
    stat: "95%",
    statLabel: "úspora času",
    icon: "Clock"
  },
  {
    id: 2,
    title: "Soulad s RVP PV 2025",
    description: "Automatické mapování na nový Rámcový vzdělávací program. Všechny povinné kapitoly, vzdělávací oblasti a kompetence.",
    stat: "100%",
    statLabel: "pokrytí RVP",
    icon: "ShieldCheck"
  },
  {
    id: 3,
    title: "Zachování identity školy",
    description: "Nepřijdete o to, co dělá vaši školu výjimečnou. Agent ŠVP zachová vaše tematické bloky, projekty, tradice a další specifika vaší školy.",
    stat: "100%",
    statLabel: "vaše DNA",
    icon: "Heart"
  },
  {
    id: 4,
    title: "Plná kontrola nad výsledkem",
    description: "Editujte, přidávejte vlastní sekce, použijte AI asistenta a exportujte do plně editovatelného Wordu.",
    stat: "∞",
    statLabel: "možností",
    icon: "Settings"
  }
];

export const HOW_IT_WORKS_STEPS = [
  {
    step: 1,
    title: "Nahrajte své staré ŠVP",
    description: "Jednoduše přetáhněte PDF nebo Word dokument vašeho současného ŠVP do aplikace. Systém přečte celý dokument a identifikuje vaši \"DNA školy\".",
    details: ["Pokročilé OCR rozpoznávání", "Extrakce všech důležitých informací", "Identifikace unikátních prvků školy"],
    icon: "Upload"
  },
  {
    step: 2,
    title: "Zkontrolujte a upřesněte",
    description: "Systém vám ukáže, co z vašeho ŠVP extrahoval. Zkontrolujte správnost, opravte nepřesnosti a doplňte chybějící informace.",
    details: ["Charakteristika školy", "Tematické bloky a projekty", "Denní režim a organizace"],
    icon: "Search"
  },
  {
    step: 3,
    title: "Vyberte, co chcete zachovat",
    description: "Rozhodněte, které prvky z vašeho současného ŠVP chcete převzít. Systém vám poradí a zobrazí důležitost jednotlivých prvků.",
    details: ["Motto a vize školy", "Tematické bloky", "Speciální projekty a programy"],
    icon: "CheckSquare"
  },
  {
    step: 4,
    title: "AI vygeneruje nový ŠVP",
    description: "Během několika minut vytvoříme kompletní ŠVP v souladu s RVP PV 2025. Všech 9 povinných kapitol s profesionálně formulovanými texty.",
    details: ["9 povinných kapitol", "Mapování na vzdělávací oblasti", "Klíčové kompetence a gramotnosti"],
    icon: "Sparkles"
  },
  {
    step: 5,
    title: "Upravte dle svých potřeb",
    description: "V intuitivním editoru si dokument přizpůsobte. Editujte texty, přidávejte sekce, použijte AI pro přepis nebo vylepšení.",
    details: ["Intuitivní online editor", "AI asistent pro přepis textu", "Vlastní kapitoly a podsekce"],
    icon: "PenTool"
  },
  {
    step: 6,
    title: "Exportujte a finalizujte",
    description: "Stáhněte si hotový dokument jako Word soubor. Plně editovatelný, s automatickým obsahem a profesionálním formátováním.",
    details: ["Export do Wordu i PDF", "Automatický obsah", "Profesionální formátování"],
    icon: "Download"
  }
];

export const FEATURES = [
  {
    id: 1,
    title: "AI Asistent pro přepis textu",
    description: "8 inteligentních režimů: Vylepšit, Přepsat jinak, Zkrátit, Rozšířit, Formálnější, Zjednodušit, Více detailů, Vlastní instrukce.",
    icon: "Bot",
    highlight: true
  },
  {
    id: 2,
    title: "Přidávání vlastních sekcí",
    description: "Vaše škola má něco unikátního? Přidejte vlastní kapitolu nebo podsekci - ekozahrada, keramická dílna, canisterapie...",
    icon: "Plus"
  },
  {
    id: 3,
    title: "Export do Wordu",
    description: "Plně editovatelný Word dokument s titulní stranou, automatickým obsahem, tabulkami a profesionálním formátováním.",
    icon: "FileText"
  },
  {
    id: 4,
    title: "Kontrola kompletnosti",
    description: "Systém kontroluje pokrytí všech vzdělávacích oblastí, kompetencí a povinných kapitol.",
    icon: "BarChart3"
  },
  {
    id: 5,
    title: "Tvorba integrovaných bloků",
    description: "Vygeneruje integrovaný blok na jakékoliv téma a automaticky doplní kódy kompetencí dle RVP PV 2025.",
    icon: "BookOpen"
  },
  {
    id: 6,
    title: "Generování denního režimu",
    description: "AI vám pomůže vytvořit přehledný denní režim přizpůsobený vašemu provozu — celodenní, polodenní i pro různé věkové skupiny.",
    icon: "CalendarDays"
  },
  {
    id: 7,
    title: "Automatické ukládání",
    description: "Nikdy nepřijdete o svou práci. Automatické ukládání každých 30 sekund, historie verzí a možnost vrátit změny.",
    icon: "Save"
  },
  {
    id: 8,
    title: "Inteligentní AI průvodce",
    description: "Celým procesem tvorby ŠVP vás provází chytrý AI agent. Krok za krokem vám poradí, co vyplnit a jak postupovat.",
    icon: "Compass"
  }
];

export const PRICING_TIERS = [
  { min: 1, max: 28, price: "8 990", label: "1–28 dětí" },
  { min: 29, max: 56, price: "10 990", label: "29–56 dětí" },
  { min: 57, max: 84, price: "13 990", label: "57–84 dětí" },
  { min: 85, max: 112, price: "15 990", label: "85–112 dětí" },
  { min: 113, max: 140, price: "18 990", label: "113–140 dětí" },
  { min: 141, max: 999, price: null, label: "Více než 140 dětí" }
];

export const PRICING_FEATURES = [
  "Vytvoření kompletního ŠVP v souladu s RVP PV 2025 pomocí našeho agenta",
  "Migrace stávajícího ŠVP",
  "Jednoduchý a intuitivní editor — úpravy zvládne každý",
  "Inteligentní AI průvodce krok za krokem",
  "Vlastní sekce a kapitoly",
  "Tvorba integrovaných bloků s kódy kompetencí",
  "Generování denního režimu",
  "Export do DOCX a PDF",
  "Kontrola kompletnosti",
  "Celý rok můžete ŠVP ladit a upravovat"
];

export const ENTERPRISE_PLAN = null;

export const TESTIMONIALS = [
  {
    id: 1,
    text: "Nemohla jsem uvěřit, jak rychle jsem měla hotový ŠVP. To, na co jsem se loni dívala měsíc, jsem s Agent ŠVP zvládla za jedno odpoledne. A výsledek je dokonce lepší!",
    author: "Mgr. Jana Nováková",
    role: "Ředitelka MŠ Sluníčko, Praha",
    rating: 5
  },
  {
    id: 2,
    text: "Nejvíc oceňuji, že jsme neztratili naše specifické projekty. Agent ŠVP je zachoval a krásně je zapracoval do nového formátu podle RVP PV 2025. Náš EVVO program a Čtecí babičky zůstaly, jen lépe popsané.",
    author: "Mgr. Petra Svobodová",
    role: "Ředitelka MŠ Píšť",
    rating: 5
  },
  {
    id: 3,
    text: "Jako zřizovatel spravuji 8 mateřských škol. S Agent ŠVP jsme ušetřili stovky hodin práce. Každá škola má kvalitní, sjednocený formát, ale zachovává svou jedinečnost. Investice se vrátila už při prvním použití.",
    author: "Ing. Martin Dvořák",
    role: "Místostarosta obce Benešov",
    rating: 5
  }
];

export const FAQ_ITEMS = [
  {
    question: "Je Agent ŠVP opravdu v souladu s RVP 2025?",
    answer: "Ano, aplikace je postavená přímo na datech z NPI (Národní pedagogický institut) a automaticky mapuje vše na aktuální verzi RVP 2025. Kontrolujeme pokrytí všech povinných oblastí, kompetencí a očekávaných výsledků učení."
  },
  {
    question: "Mohu si výsledný dokument upravit?",
    answer: "Samozřejmě! Vše můžete editovat přímo v aplikaci a pak exportovat jako plně editovatelný Word dokument. Ve Wordu můžete provést jakékoliv další úpravy."
  },
  {
    question: "Co když nemám žádné staré ŠVP?",
    answer: "Můžete vytvořit ŠVP od nuly. Stačí vyplnit základní informace o škole a systém vygeneruje kompletní ŠVP podle RVP 2025. Poté si ho upravíte podle svých potřeb."
  },
  {
    question: "Můžu přidat vlastní kapitoly?",
    answer: "Ano! Můžete přidat libovolné vlastní kapitoly nebo podsekce. Například sekci o vašem unikátním projektu, zaměření školy, specifických programech atd."
  },
  {
    question: "Jak mě Agent ŠVP provede celým procesem?",
    answer: "Agent ŠVP obsahuje inteligentního AI průvodce, který vás vede krok za krokem celým procesem tvorby ŠVP. Od zadání profilu školy přes kontrolu dat až po finální export — vždy víte, co máte dělat dál."
  },
  {
    question: "Jsou v ceně aktualizace?",
    answer: "Ano, všechny aktualizace aplikace jsou zahrnuté v ceně. Pokud vyjde nová verze RVP, aktualizujeme systém bez dalších poplatků."
  }
];

export const RVP_COMPLIANCE = {
  areas: [
    "Dítě a jeho tělo (Biologická)",
    "Dítě a jeho psychika (Psychologická)",
    "Dítě, ten druhý a společnost (Sociálně-kulturní)",
    "Dítě a svět (Environmentální)"
  ],
  competencies: [
    "K učení",
    "Komunikační",
    "K občanství a udržitelnosti",
    "Osobnostní a sociální",
    "K podnikavosti a pracovní",
    "K řešení problémů",
    "Kulturní",
    "Digitální"
  ],
  literacies: ["Čtenářská gramotnost", "Matematická gramotnost"],
  themes: ["Péče o sebe a druhé", "Společnost pro všechny", "Udržitelné prostředí"],
  chapters: [
    "Identifikační údaje",
    "Charakteristika školy",
    "Podmínky vzdělávání",
    "Organizace",
    "Charakteristika vzdělávacího programu",
    "Vzdělávací obsah",
    "Vzdělávací oblasti a očekávané výsledky",
    "Evaluační systém"
  ]
};

export const SPECIAL_OFFER = {
  code: "PRVNI2025",
  discount: "20%",
  validUntil: "31. 12. 2025",
  migrationOriginal: "2 490 Kč",
  migrationSale: "1 990 Kč",
  premiumOriginal: "4 990 Kč",
  premiumSale: "3 990 Kč"
};

export const COMPANY_INFO = {
  name: "#TouchOfLucky s.r.o.",
  ico: "09094075",
  web: "www.agentsvp.cz",
  email: "info@agentsvp.cz",
  phone: "+420 739 921 359",
  address: "Sídlo: Zámostní 1155/27, Slezská Ostrava, 710 00 Ostrava",
  address2: "Provozovna: Wilsonova 102/12, 750 02 Přerov I-Město"
};

// Termíny pro MŠ (úterý 18:00, čtvrtek 10:00)
export const WEBINAR_DATES_MS = [
  { date: "2026-08-25T18:00:00", timeLabel: "18:00–19:00", dayLabel: "Út 25. 8." },
  { date: "2026-08-27T10:00:00", timeLabel: "10:00–11:00", dayLabel: "Čt 27. 8." },
  { date: "2026-09-03T10:00:00", timeLabel: "10:00–11:00", dayLabel: "Čt 3. 9." },
  { date: "2026-09-08T18:00:00", timeLabel: "18:00–19:00", dayLabel: "Út 8. 9." },
  { date: "2026-09-10T10:00:00", timeLabel: "10:00–11:00", dayLabel: "Čt 10. 9." },
  { date: "2026-09-15T18:00:00", timeLabel: "18:00–19:00", dayLabel: "Út 15. 9." },
  { date: "2026-09-17T10:00:00", timeLabel: "10:00–11:00", dayLabel: "Čt 17. 9." },
  { date: "2026-09-22T18:00:00", timeLabel: "18:00–19:00", dayLabel: "Út 22. 9." },
  { date: "2026-09-24T10:00:00", timeLabel: "10:00–11:00", dayLabel: "Čt 24. 9." },
  { date: "2026-09-29T18:00:00", timeLabel: "18:00–19:00", dayLabel: "Út 29. 9." }
];

// Termíny pro ZŠ (středa 18:00)
export const WEBINAR_DATES_ZS = [
  { date: "2026-08-26T18:00:00", timeLabel: "18:00–19:00", dayLabel: "St 26. 8." },
  { date: "2026-09-02T18:00:00", timeLabel: "18:00–19:00", dayLabel: "St 2. 9." },
  { date: "2026-09-09T18:00:00", timeLabel: "18:00–19:00", dayLabel: "St 9. 9." },
  { date: "2026-09-16T18:00:00", timeLabel: "18:00–19:00", dayLabel: "St 16. 9." },
  { date: "2026-09-23T18:00:00", timeLabel: "18:00–19:00", dayLabel: "St 23. 9." },
  { date: "2026-09-30T18:00:00", timeLabel: "18:00–19:00", dayLabel: "St 30. 9." }
];

export const APP_URLS = {
  register: "https://app.agentsvp.cz/registrace"
};
